import { captureException } from '@sentry/browser'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSharedStore = defineStore('shared', () => {
  const loading = ref(false)
  const errorState = ref<unknown | null>(null)

  const resetState = () => {
    loading.value = false
    errorState.value = null
  }

  const setLoading = (payload: boolean) => {
    loading.value = payload
  }

  const clearError = () => {
    errorState.value = null
  }

  const setError = (newError: unknown) => {
    captureException(newError)
    errorState.value = newError
  }

  const init = () => {
    clearError()
    setLoading(true)
  }

  const success = () => {
    setLoading(false)
  }

  const errorAction = (newError: unknown) => {
    setError(newError)
    setLoading(false)
  }

  return {
    loading,
    error: errorState,
    resetState,
    setLoading,
    clearError,
    setError,
    init,
    success,
    errorAction,
  }
})
